<template>
  <button
    :disabled="loading"
    @click="updateOrderStatus()"
    class="btn main-bg ml-2"
  >Actualizar estado
  </button>
</template>

<script>
import { BranchOfficeService } from '../../services/BranchOfficeService';
import { BaseService } from '../../services/BaseService'

export default {
  name: 'UpdateOrderStatusBtn',
  props: [
    'order_id',
    'branch_office_id',
    'user_id'
  ],
  data:function(){
    return {
      loading: false,
      branchOfficeService: new BranchOfficeService(),
    }
  },
  methods: {
    async updateOrderStatus() {

      const option = await Swal.fire({
        title: "Seleccione el estado de la orden",
        input: "select",
        inputOptions: this.$constants.posibleOrderStatus,
        showCancelButton: true,
        confirmButtonColor: "#4279AF",
        cancelButtonColor: "#d33",
        cancelButtonText: '<i class="fa fa-close"></i> Cancelar',
        confirmButtonText: '<i class="fa fa-check"></i> Aceptar',
        backdrop: false,
        reverseButtons: true,
      });

      if(option.dismiss){
        return;
      }
      
      let newStatus = option.value;
      this.loading = true;

      if (newStatus != "") {
        if (newStatus == 0) {
          newStatus = this.$constants.orderStatus.RECIVED;
        } else if (newStatus == 1) {
          newStatus = this.$constants.orderStatus.IN_REPART;
        } else if (newStatus == 2) {
          newStatus = this.$constants.orderStatus.ARRAIVED;
        }
        console.log('params: ', [
          this.branch_office_id,
          this.order_id,
          newStatus,
          this.user_id
        ]);
        
        try {
          await this.branchOfficeService.changeOrderStatus(
            this.branch_office_id,
            this.order_id,
            newStatus,
            this.user_id
          );

          await new BaseService().http("saveOrder", "POST", {orderId: this.order_id, companyId: this.branch_office_id})

          this.$helpers.toast("Estado actualizado!");

          this.$emit('status-updated', {
            status: newStatus,
            order_id: this.order_id
          });

        } catch (error) {
          this.$helpers.message("Error", error.message);
        }
        
      }  

      this.loading = false;
    },
  },  
}
</script>

<style lang="scss" scoped>

</style>